import React, { useEffect, useState } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const CalendarModalData = ({ selectedDate, onSelectDate, day, month, year }) => {
  const [viewDate, setViewDate] = useState(new Date(selectedDate));

  const getMonthDays = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const days = [];
    for (let i = 0; i < firstDay; i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) days.push(i);
    return days;
  };

  const handlePrevMonth = () => {
    const newDate = new Date(viewDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setViewDate(newDate);
  };

  const handleNextMonth = () => {
    const newDate = new Date(viewDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setViewDate(newDate);
  };

  const handlePrevYear = () => {
    const newDate = new Date(viewDate);
    newDate.setFullYear(newDate.getFullYear() - 1);
    setViewDate(newDate);
  };

  const handleNextYear = () => {
    const newDate = new Date(viewDate);
    newDate.setFullYear(newDate.getFullYear() + 1);
    setViewDate(newDate);
  };

  const handleDateClick = (day) => {
    if (day && !isFutureDate(day)) {
      const picked = new Date(viewDate);
      picked.setDate(day);
      onSelectDate(picked);
    }
  };

  const today = new Date();

  const isToday = (day) =>
    day &&
    today.getDate() === day &&
    today.getMonth() === viewDate.getMonth() &&
    today.getFullYear() === viewDate.getFullYear();

  const isSelected = (day) =>
    day &&
    selectedDate.getDate() === day &&
    selectedDate.getMonth() === viewDate.getMonth() &&
    selectedDate.getFullYear() === viewDate.getFullYear();

  const isFutureDate = (day) => {
    if (!day) return false;
    const picked = new Date(viewDate);
    picked.setDate(day);
    picked.setHours(0, 0, 0, 0);
    return picked > new Date().setHours(0, 0, 0, 0);
  };

  const days = getMonthDays(viewDate);

  useEffect(() => {
    setViewDate(new Date(selectedDate));
  }, [selectedDate]);

  return (
    <div className="d-flex bg-white border br3 shadow-sm">
      <div className="calendar-right">
        <div className="hstack justify-content-between border-bottom">
          <div className="p-2 hstack gap-1">
            <div className="CP" onClick={handlePrevMonth}>
              <MdKeyboardArrowLeft className="mb-1" title="Previous Month" />
            </div>
            <p className="m-0" style={{ fontSize: 12 }}>
              {viewDate.toLocaleString("default", { month: "long" })}
            </p>
            <div className="CP" onClick={handleNextMonth}>
              <MdKeyboardArrowRight className="mb-1" title="Next Month" />
            </div>
          </div>
          <div className="p-2 hstack gap-1">
            <div className="CP" onClick={handlePrevYear}>
              <MdKeyboardArrowLeft className="mb-1" title="Previous Year" />
            </div>
            <p className="m-0" style={{ fontSize: 12 }}>
              {viewDate.getFullYear()}
            </p>
            <div className="CP" onClick={handleNextYear}>
              <MdKeyboardArrowRight className="mb-1" title="Next Year" />
            </div>
          </div>
        </div>

        <div className="calendar-weekdays pt-2 text-muted" style={{ fontSize: 12 }}>
          {["S", "M", "T", "W", "T", "F", "S"].map((d) => (
            <div key={d}>{d}</div>
          ))}
        </div>

        <div className="calendar-days">
          {days.map((day, index) => {
            const selected = isSelected(day);
            const todayMark = isToday(day);
            const future = isFutureDate(day);

            return (
              <div
                key={index}
                className={`calendar-day hstack text-center justify-content-center p-2 ${future ? "text-muted" : "CP"} ${selected ? "selected" : ""} ${todayMark ? "today" : ""}`}
                onClick={() => !future && handleDateClick(day)}
                style={{
                  fontSize: 12,
                  width: 30,
                  height: 30,
                  cursor: future ? "not-allowed" : "pointer",
                  opacity: future ? 0.5 : 1,
                }}
              >
                {day || ""}
              </div>
            );
          })}
        </div>

        <div className="border-top hstack justify-content-between p-2">
          <div
            className="CP"
            style={{ fontSize: 12 }}
            title="Select Yesterday"
            onClick={() => onSelectDate(new Date(Date.now() - 86400000))}
          >
            Yesterday
          </div>
          <div
            className="CP"
            style={{ fontSize: 12 }}
            title="Select Today"
            onClick={() => onSelectDate(new Date())}
          >
            Today
          </div>
          {new Date().setHours(0, 0, 0, 0) >= new Date(Date.now() + 86400000).setHours(0, 0, 0, 0) ? (
            <div
              className="CP"
              style={{ fontSize: 12 }}
              title="Select Tomorrow"
              onClick={() => onSelectDate(new Date(Date.now() + 86400000))}
            >
              Tomorrow
            </div>
          ) : (
            <div
              style={{ fontSize: 12, opacity: 0.5, cursor: "not-allowed" }}
              title="Future date disabled"
            >
              Tomorrow
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendarModalData;